import React from "react";
import { Loader, Placeholder } from 'rsuite';

const LoaderDashboard =()=>{

    return(

    <div>
        <Loader content="Loading..." vertical />
    </div>
    );
    
};

export default LoaderDashboard;